import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';
import { PatientModel } from 'src/app/models/PatientsModel';
import { PatientsService } from 'src/app/services/PatientsService';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';   ///=== for searching pop up
import { LocalStorage, LocalStorageService } from 'ngx-webstorage';
import { DataBankService } from 'src/app/services/DataBankService';
import { DatabankModel } from 'src/app/models/DataBankModel';
@Component({
  selector: 'app-popuppatientsearch',
  templateUrl: './popuppatientsearch.component.html',
  styleUrls: ['./popuppatientsearch.component.css']
})
export class PopuppatientsearchComponent implements OnInit {
  //------------------- patient decliration ------------------------
  patientCode = '';
  patientFName = '';
  diagnosis = '';
  patientLName = '';
  patientFullName = '';
  birthDate = '2022-01-01';
  education = '';
  nationality = '';
  occupation = '';
  referredFrom = '';
  telHome = '';
  telBusin = '';
  telMobile = '';
  addressHome = '';
  addressBusin = '';
  email = '';
  relativeName = '';
  relativeTelHome = '';
  relativeTelBusin = '';
  relativeTelMobile = '';
  relativeAddressHome = '';
  relativeAddressBusin = '';
  userDef1 = '';
  userDef2 = '';
  userDefDate = '';
  userDefNum = '';
  dateEntry = '';
  gender = '';
  marital = '';
  noChildren = '';
  ageOldest = '';
  ageYoungest = '';
  status = '';
  cancerID = '';
  docCode = '';
  txtRef = '';
  pathology = '';
  menstrual = '';
  since = '';
  contraception = '';
  pregnancy = '';
  smoker = '';
  smokerType = '';
  noPacks = '';
  sSince = 0;
  mSince = '';
  drinkingAlcohol = '';
  deteRelapse = '';
  gov='';
  compCode = '1';
  userID = 'sa';
  ageYear=0;
  modifiedDate = '2022-01-01';
  patientList: DatabankModel[] = [];
  @Output() submitClicked = new EventEmitter<any>();

  constructor(public pateintssService: DataBankService, public patients: DatabankModel,
    public dialogRef: MatDialogRef<PopuppatientsearchComponent>,
    public storage: LocalStorageService,
    @Inject(MAT_DIALOG_DATA)
    public patientSelectedData: PatientModel) { }


  ngOnInit(): void {
    this.retrivePatientsTop();
  }

  retrivePatients() {
    this.patientList = [];
    this.pateintssService.getPatientLookup(this.patientCode, this.patientFName,this.telMobile,this.telHome,this.telBusin,this.cancerID, this.compCode).subscribe((data: DatabankModel[]) => {
      for (let i = 0; i < data.length; i++) {
        this.patientList[i] = data[i];
      }
      console.log(data);
    })
  }
  retrivePatientsTop() {
    this.pateintssService.getpatientLookupTop(this.compCode).subscribe((data: DatabankModel[]) => {
      for (let i = 0; i < data.length; i++) {
        this.patientList[i] = data[i];
      }
      console.log(data);
    })
  }
  clickSelect(){
    this.storage.store('stgSearchCode', this.patientCode);
  }
  SelectPatient(patient: DatabankModel){

    this.patientSelectedData.patientCode = patient.patientCode
    this.patientSelectedData.patientFName = patient.patientFName
    this.patientSelectedData.birthDate= patient.birthDate
    this.patientSelectedData.diagnosis= patient.diagnosis
    this.patientSelectedData.gender= patient.gender
    this.patientSelectedData.telMobile= patient.telMobile
    this.patientSelectedData.status= patient.status
    this.patientSelectedData.pathology= patient.pathology
    this.patientSelectedData.cancerID= patient.cancerID
    this.patientSelectedData.dateEntry= patient.dateEntry
    this.patientSelectedData.modifiedDate = patient.modifiedDate
    this.patientSelectedData.pathology = patient.pathology
    this.patientSelectedData.ageYear = patient.ageYear
    this.patientSelectedData.cancerID = patient.cancerID
    this.patientSelectedData.addressHome = patient.addressHome
    this.patientSelectedData.docCode = patient.docCode
    this.patientSelectedData.marital = patient.marital
    this.patientSelectedData.pathology = patient.pathology
    this.patientSelectedData.email = patient.email
    this.patientSelectedData.education = patient.education
    this.patientSelectedData.occupation = patient.occupation
    this.patientSelectedData.nationality = patient.nationality
    this.patientSelectedData.gov = patient.gov
    this.patientSelectedData.telHome = patient.telHome
    this.patientSelectedData.status = patient.status
    this.patientSelectedData.telBusin = patient.telBusin


    this.patientSelectedData.userID = LocalStorage.name
    this.patientSelectedData.dateEntry = patient.dateEntry
    this.patientSelectedData.modifiedDate = patient.modifiedDate
    this.patientSelectedData.compCode = patient.compCode
    this.submitClicked.emit(this.patientSelectedData);
    this.dialogRef.close();

  }


}
